import { render, staticRenderFns } from "./culturalCreativeDetail.vue?vue&type=template&id=d33e41a0&scoped=true"
import script from "./culturalCreativeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./culturalCreativeDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./culturalCreativeDetail.vue?vue&type=style&index=0&id=d33e41a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33e41a0",
  null
  
)

export default component.exports